
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
    ORTLONGGAME_ACTION,
    ALL_ORTLONGGAME,
    ADD_ORTLONGGAME,
    FETCH_ORTLONGGAME,
    EDIT_ORTLONGGAME,
    DELETE_ORTLONGGAME,
    FETCH_ORTLONGGAMECHART,
    FETCH_ORTLONGGAMESHOTCHART,
} from 'Actions/types';

import { NotificationManager } from 'react-notifications';
/**
 * On Range Long Game Test Actions
 */

    export const allORTLongGameTest = () =>{    
        
        return (dispatch) => { 
            dispatch({ type: ORTLONGGAME_ACTION });
            return axios.get(AppConfig.apiurl+'/api/getonrlonggame', { headers: AuthHeader.header })         
            .then(response => {             
                const alldata=response.data.data;
                dispatch({ type: ALL_ORTLONGGAME, payload: alldata });
            });
        }        

    }

    export const studentORTLongGameTest = (id, start, end) =>{
    
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end
        }

        return (dispatch) => { 
            dispatch({ type:ORTLONGGAME_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/studentonrlonggame', payload,{ headers: AuthHeader.header })         
            .then(response => { 
                const alldata=response.data.data;
                dispatch({ type: ALL_ORTLONGGAME, payload: alldata }); 
            });
        
        }
    }

    export const addORTLongGameTest = (data, sepmore) =>{
        var stdid=data.target.student.value;
        var payload={
            "totval":1,
            "student_1":data.target.student.value,
            "sgdate":data.target.seldate.value,
            "shtot_1":sepmore,
        }

        for (let i = 0; i<sepmore; i++) {        
            var club='club_'+i;            
            var clubval=data.target[club].value;
            var shot='shot_'+i;            
            var shotval=data.target[shot].value;
            var right='right_'+i;            
            var rightval=data.target[right].value;
            var left='left_'+i;            
            var leftval=data.target[left].value;    
            var short='short_'+i;            
            var shortval=data.target[short].value;
            var long='long_'+i;            
            var longval=data.target[long].value;        
            var contact='contact_'+i;            
            var contactval=data.target[contact].value;
            var area='area_'+i;            
            var areaval=data.target[area].value;          
            var process='process_'+i;            
            var processval=data.target[process].value;
            var septravel='missedgreen_'+i;            
            var setrvalval=data.target[septravel].value;           
            
            var adval=i+1;
            var clubadd='club_1_'+adval;
            var shotadd='shot_1_'+adval;
            var rightadd='right_1_'+adval;  
            var leftadd='left_1_'+adval;  
            var shortadd='short_1_'+adval;  
            var longadd='long_1_'+adval;  
            var contadd='contact_1_'+adval;  
            var areaadd='area_1_'+adval;      
            var septraveladd='outside_1_'+adval; 
            var processadd='process_1_'+adval;
            
            payload[clubadd]=clubval;
            payload[shotadd]=shotval;
            payload[rightadd]=rightval;
            payload[leftadd]=leftval;
            payload[shortadd]=shortval;
            payload[longadd]=longval;
            payload[contadd]=contactval;
            payload[areaadd]=areaval;           
            payload[septraveladd]=setrvalval;
            payload[processadd]=processval;            
    
        }         

        return (dispatch) => { 
            dispatch({ type:ORTLONGGAME_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/addonrlonggame', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    var start='';
                    var end='';
                    studentORTLongGameTest(stdid, start, end)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: ADD_ORTLONGGAME});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const fetchORTLongGameTest = (id, date) =>{
    
        var payload={
            "id":id,
            "date":date
        }
        return (dispatch) => { 
            dispatch({ type:ORTLONGGAME_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/getonrlonggamedetails', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: FETCH_ORTLONGGAME, payload: resdata.data});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const editORTLongGameTest = (data, sepmore, oldate) =>{
        var stdid=data.target.student.value;
        var payload={
            "totval":1,
            "student":data.target.student.value,
            "sgdate":data.target.seldate.value,
            "shtot_1":sepmore,
            "olddate":oldate,
        }

        for (let i = 0; i<sepmore; i++) {        
            var club='club_'+i;            
            var clubval=data.target[club].value;
            var shot='shot_'+i;            
            var shotval=data.target[shot].value;
            var right='right_'+i;            
            var rightval=data.target[right].value;
            var left='left_'+i;            
            var leftval=data.target[left].value;    
            var short='short_'+i;            
            var shortval=data.target[short].value;
            var long='long_'+i;            
            var longval=data.target[long].value;        
            var contact='contact_'+i;            
            var contactval=data.target[contact].value;
            var area='area_'+i;            
            var areaval=data.target[area].value;          
            var process='process_'+i;            
            var processval=data.target[process].value;
            var septravel='missedgreen_'+i;            
            var setrvalval=data.target[septravel].value;           
            
            var adval=i+1;
            var clubadd='club_1_'+adval;
            var shotadd='shot_1_'+adval;
            var rightadd='right_1_'+adval;  
            var leftadd='left_1_'+adval;  
            var shortadd='short_1_'+adval;  
            var longadd='long_1_'+adval;  
            var contadd='contact_1_'+adval;  
            var areaadd='area_1_'+adval;      
            var septraveladd='outside_1_'+adval; 
            var processadd='process_1_'+adval;
            
            payload[clubadd]=clubval;
            payload[shotadd]=shotval;
            payload[rightadd]=rightval;
            payload[leftadd]=leftval;
            payload[shortadd]=shortval;
            payload[longadd]=longval;
            payload[contadd]=contactval;
            payload[areaadd]=areaval;           
            payload[septraveladd]=setrvalval;
            payload[processadd]=processval;            
    
        }  

        return (dispatch) => { 
            dispatch({ type:ORTLONGGAME_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/editonrlonggame', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    var start='';
                    var end='';
                    studentORTLongGameTest(stdid, start, end)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: EDIT_ORTLONGGAME});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const deleteORTLongGameTest = (id, date) =>{
        
        var payload={
            "id":id,
            "date":date
        }
        
        return (dispatch) => { 
            dispatch({ type:ORTLONGGAME_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/deleteonrlonggame', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    var start='';
                    var end='';
                    studentORTLongGameTest(id, start, end)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: DELETE_ORTLONGGAME});                    
                }                
                
            });
        
        }
    }

    export const fetchORTLongGameReport = (id, start, end, club, shot, area, contact) =>{
        
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end,
            "club":club,
            "shot":shot,
            "contact":contact,
            "area":area,         
        }
        
        return (dispatch) => { 
            dispatch({ type:ORTLONGGAME_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/onrangelonggamereport', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data.data;
                dispatch({ type: FETCH_ORTLONGGAMECHART, payload: resdata});                 
                return Promise.resolve(resdata);  
            });
        
        }
    }

    export const fetchORTLongGameShotChart = (id, start, end, club, shot, area, contact, val) =>{
        
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end,
            "club":club,
            "shot":shot,
            "contact":contact,
            "area":area,
            "section":val            
        }
        
        return (dispatch) => { 
            dispatch({ type:ORTLONGGAME_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/onrangelonggameshotchart', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data.data;
                dispatch({ type: FETCH_ORTLONGGAMESHOTCHART, payload: resdata});                 
                return Promise.resolve(resdata);
            });
        
        }
    }

